define(function (require, exports, module) {
    'use strict';

    var BackendResponseData = require('./BackendResponseData');
    var UploadReason = require('../../UploadReason');
    var IllegalContentFail = require('../../fails/IllegalContentFail');
    var FileTooLargeError = require('../../errors/FileTooLargeError');
    var InternalError = require('../../errors/InternalError');
    var MalformedError = require('../../errors/MalformedError');
    var UnknownError = require('../../errors/UnknownError');

    /**
     * @namespace
     */
    var backendResponseTextOfPost = {
        /**
         * Внутренняя ошибка сервера.
         * "-EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;internal\r\n"
         * @type {string}
         */
        ERROR_INTERNAL: 'internal',

        /**
         * Слишком большой файл.
         * "-EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;too large\r\n"
         * @type {string}
         */
        ERROR_TOO_LARGE: 'too large',

        /**
         * Заблокированный контент.
         * "-EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;illegal\r\n"
         * @type {string}
         */
        FAIL_ILLEGAL: 'illegal',

        /**
         * Matches response text like:
         * "EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152\r\n"
         * @type {RegExp}
         */
        successPattern: /^([0-9ABCDEF]{40});(\d+)$/m,

        /**
         * Matches response text like:
         * "-EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;illegal\r\n"
         * @type {RegExp}
         */
        errorPattern: /^-([0-9ABCDEF]{40});(\d+);([-\w]+)$/m,

        /**
         * @param {string} errorType
         * @returns {UploadReason}
         */
        createError: function (errorType) {
            var source = UploadReason.SOURCE_BACKEND;
            var stack;
            var error;

            switch (errorType) {
                case backendResponseTextOfPost.FAIL_ILLEGAL:
                    stack = new Error('IllegalContentFail');
                    error = new IllegalContentFail(stack, source);

                    break;

                case backendResponseTextOfPost.ERROR_TOO_LARGE:
                    stack = new Error('FileTooLargeError');
                    error = new FileTooLargeError(stack, source);

                    break;

                case backendResponseTextOfPost.ERROR_INTERNAL:
                    stack = new Error('InternalError');
                    error = new InternalError(stack, source);

                    break;

                default:
                    // Upload-сервер прислал ошибку в правильном формате,
                    // но нам не известен такой тип ошибки.
                    stack = new Error('UnknownError');
                    error = new UnknownError(stack, source, errorType);
            }

            return error;
        },

        /**
         * Parse response text like:
         * "EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152\r\n"
         * @param {string} responseText
         * @returns {BackendResponseData|null}
         */
        parseSuccess: function (responseText) {
            var pattern = backendResponseTextOfPost.successPattern;
            var matches = responseText.match(pattern);
            var result;

            if (Array.isArray(matches)) {
                var HASH = 1;
                var SIZE = 2;
                var hash = matches[HASH];
                var size = matches[SIZE];

                size = parseInt(size, 10);
                result = new BackendResponseData(hash, size);
            } else {
                result = null;
            }

            return result;
        },

        /**
         * Parse response text like:
         * "-EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;illegal\r\n"
         * @param {string} responseText
         * @returns {BackendResponseData|null}
         */
        parseError: function (responseText) {
            var pattern = backendResponseTextOfPost.errorPattern;
            var matches = responseText.match(pattern);
            var result;

            if (Array.isArray(matches)) {
                var HASH = 1;
                var SIZE = 2;
                var ERROR = 3;
                var hash = matches[HASH];
                var size = matches[SIZE];
                var error = matches[ERROR];

                size = parseInt(size, 10);
                error = backendResponseTextOfPost.createError(error);
                result = new BackendResponseData(hash, size, error);
            } else {
                result = null;
            }

            return result;
        },

        /**
         * Parse response text like:
         * "EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152\r\n"
         * "-EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;illegal\r\n"
         * @param {string} responseText
         * @returns {BackendResponseData}
         */
        parse: function (responseText) {
            var result = backendResponseTextOfPost.parseSuccess(responseText);

            if (!result) {
                result = backendResponseTextOfPost.parseError(responseText);

                if (!result) {
                    var hash;
                    var size;
                    var source = UploadReason.SOURCE_BACKEND;
                    var stack = new Error('MalformedError');
                    var error = new MalformedError(stack, source, responseText);

                    result = new BackendResponseData(hash, size, error);
                }
            }

            return result;
        },
    };

    module.exports = backendResponseTextOfPost;
});
